import React, { useState, useEffect, useMemo } from 'react'
import { Empty, Select as S, Spin } from 'antd'
import _ from 'lodash'
import userApi from 'src/api/userApi'

export function CustomSelect ({ multiple, options = [], unSorted, showSearch = true, ...rest }) {
  const [multipleMode, setMultipleMode] = useState(false)
  useEffect(() => {
    setMultipleMode(!!multiple)
  }, [multiple])
  const sortedOptions = useMemo(() => {
    if (unSorted) return options
    return _.sortBy(options, 'label')
  }, [options])
  return (
    <S
      mode={multipleMode ? 'multiple' : undefined}
      maxTagCount={2}
      style={{ width: '100%' }}
      allowClear
      options={sortedOptions}
      {...rest}
      filterOption={filterOption}
      showSearch={showSearch}
      showArrow
    />
  )
}
function filterOption (inputValue, option) {
  inputValue = removeVietnameseTones((inputValue || '').toLowerCase())
  const label = removeVietnameseTones(`${option.label || ''}`.toLowerCase())
  return label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
}
function removeVietnameseTones (str) {
  str = str.normalize('NFC')
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a')
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e')
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i')
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o')
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u')
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y')
  str = str.replace(/đ/g, 'd')
  str = str.replace(/ + /g, ' ')
  str = str.trim()
  return str
}

export function UserDebounceSelect ({
  fetchOptions = fetchUserList,
  debounceTimeout = 500,
  formatOptions,
  notFoundContent,
  isClear,
  ...props
}) {
  const [fetching, setFetching] = React.useState(false)
  const [options, setOptions] = React.useState([])
  const fetchRef = React.useRef(0)
  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1
      const fetchId = fetchRef.current
      setOptions([])
      setFetching(true)
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          return
        }
        if (typeof formatOptions === 'function') {
          newOptions = formatOptions(newOptions)
        }
        setOptions(newOptions)
        setFetching(false)
      })
    }

    return _.debounce(loadOptions, debounceTimeout)
  }, [fetchOptions, debounceTimeout])
  
  const handleClear = (value) => {
    if(isClear) {
      setOptions([])
    }
  }

  return (
    <S
      filterOption={false}
      onSearch={debounceFetcher}
      showSearch
      onClear={handleClear}
      maxTagCount={1}
      notFoundContent={
        fetching
          ? (
            <Spin size='small' />
            )
          : (
            notFoundContent ? notFoundContent : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )
      }
      style={{ width: '100%' }}
      {...props}
      options={options}
    />
  )
}

async function fetchUserList (userName) {
  if (!userName) return
  const { data, status } = await userApi.searchAnyByUserName(userName)
  if (status === 200 && data) {
    return data.map((user) => ({ value: user.id, label: user.userName }))
  }
}
